import $ from 'jquery';

export default class MobileNavigation {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);
    this.mobileDropdownButton = $('.nav-item.dropdown', this.el);
    this.mobileDropdown = $('.mobile-dropdown', this.el);

    this.windowWidth = $(window).width();

    $('.dropdown > a', this.el).on('click.mobile-navigation', this.toggleExpand.bind(this));
    $('.nav-item.dropdown', this.el).on('click.mobile-navigation', () => this.toggleMobileNav());
    $(document).on('close-mobile-nav', this.closeMobileNav.bind(this));

    $(window).on('resize.mobile-navigation', () => {
      const isWidthIncrease = this.windowWidth !== $(window).width();
      if (($(window).width() > 720) && this.mobileDropdownButton.hasClass('active') && isWidthIncrease) {
        this.closeMobileNav();
      }
      this.windowWidth = $(window).width();
    });
  }

  openMobileNav() {
    this.mobileDropdownButton.addClass('active');
    this.mobileDropdownButton.attr('aria-expanded', true);
    this.mobileDropdown.show();
  }

  closeMobileNav() {
    this.mobileDropdownButton.removeClass('active');
    this.mobileDropdownButton.attr('aria-expanded', false);
    this.mobileDropdown.hide();
  }

  toggleMobileNav() {
    if (this.mobileDropdownButton.hasClass('active')) {
      this.closeMobileNav();
    } else {
      this.openMobileNav();
    }
  }

  toggleExpand(e) {
    const button = $(e.currentTarget, this.el).parent();
    const listItem = button.closest('li.list-item');
    const childList = button.find('> .list');

    // Navigate to menu link if it is open already
    const isIcon = $(e.target).hasClass('icon');
    const isExpanded = listItem.hasClass('expanded');
    if (isExpanded && !isIcon) { return; }

    // Otherwise, open menu
    e.preventDefault();

    button.siblings('.expanded').each((index, el) => {
      const $el = $(el);
      $el.closest('li.list-item').removeClass('expanded');
      $el.find('> .list').hide();
    });
    listItem.toggleClass('expanded');
    childList.toggle();

    listItem.attr('aria-expanded', listItem.hasClass('expanded'));
  }

  unload() {
    $('.dropdown > a', this.el).off('click.mobile-navigation');
    $('.nav-item.dropdown', this.el).off('click.mobile-navigation');
    $(document).off('close-mobile-nav');
    $(window).off('resize.mobile-navigation');
  }
}
